<template>
    <div>
        <div class="agwMonitor-title">
        	<Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
                <BreadcrumbItem to="/network/agwMonitor">{{$t('alarms.network.AppGateway.title')}}</BreadcrumbItem>
                <BreadcrumbItem>
                    <a @click="ipAddress">{{ $t('alarms.common.alertRule') }}</a>
                </BreadcrumbItem>
            </Breadcrumb>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.common.alertRule')">
                    <div class="agwMonitor-top">
                        <agw-warning-search></agw-warning-search>
                    </div>
                    <table-agw-warning></table-agw-warning>
                </TabPane>
            </Tabs>
        </template>
        
    </div>
</template>

<script>
    import AgwWarningSearch from '../agw/AgwWarningSearch'
    import TableAgwWarning from '../agw/TableAgwWarning'

    export default {
        name: 'AgwWarning',
        components: {
            AgwWarningSearch,
            TableAgwWarning
        },
        data(){
            return {
                id:'',
                accountId:'',
                accountTypeName:'',
                accountName:'',
                region:'',
                privateIp:''
            }
        },
         methods:{
         	// 点击返回详情页
            ipAddress: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.region=this.$route.query.region;
                this.privateIp=this.$route.query.privateIp;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.accountName=this.$route.query.accountName;
                this.name=this.$route.query.name;
                this.$router.push({path:'/network/agwDetail/',query: {id: this.id,accountId:this.accountId,region:this.region,privateIp:this.privateIp,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name}});
            }
        }
    }
</script>

<style scoped>
    .agwMonitor-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .agwMonitor-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/agw/AgwWarning.vue